import { z } from 'zod';

export const $UpdateCandidateRequest = z.object({
  phone: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  age: z.number().nullable(),
  salary: z.number().nullable().optional(),
  currencyId: z.number().nullable().optional(),
  activitySphereIds: z.array(z.number()).optional(),
  employmentTypeIds: z.array(z.number()).optional(),
  scheduleWorkIds: z.array(z.number()).optional(),
  skillIds: z.array(z.number()).optional(),
  experience: z.string().nullable().optional(),
  desiredJob: z.string().nullable().optional(),
  paymentPeriodId: z.number().nullable().optional(),
  status: z.string().optional(),
  interviewRequired: z.boolean().optional(),
  employmentDate: z.string().nullable().optional(),
  preferredCommunicationLanguage: z.string().nullable().optional(),
  generalInfo: z.string().nullable().optional(),
  educationLevel: z
    .object({
      id: z.number().nullable(),
      professionName: z.string().max(255).nullable(),
    })
    .nullable()
    .optional(),
  cityIds: z.array(z.number()).optional(),
  allCities: z.boolean().optional(),
});
